import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";
import { FolioFactura } from "app/features/componentes/foliofactura";
import { SelectorSimpleFactory } from "app/features/selectores/logic";

export interface Props {
    value: models.FiltroRep;
    onChange: (value: models.FiltroRep) => void;
}

const LimiteFacturas = SelectorSimpleFactory([25, 50, 100, 200, 500, 1000, 2000], x => x, x => "" + x);

/**
* Componente para editar un FiltroGuia
*/
export class FiltroREPComponent extends React.PureComponent<Props> {
    errors = () => validation.getErrors(this.rules, this.props.value);
    getField = formfields(() => this.props, this.errors);

    get rules(): validation.Rules<models.FiltroRep> {
        return {};
    }


    /**
     Establece la hora desde a la primer hora del día 12:00 am
     */
    private onFechaDesdeChange = (x: Date | null, key: keyof models.FiltroRep) => {
        if (x) {
            var fecha = new Date(x);
            fecha.setHours(0, 0, 0, 0);
            const viejo = this.props.value;
            const cambioFecha: Partial<models.FiltroRep> = { [key]: fecha };
            this.props.onChange({ ...viejo, ...cambioFecha });
        } else {
            const viejo = this.props.value;
            const cambioFecha: Partial<models.FiltroRep> = { [key]: null };
            this.props.onChange({ ...viejo, ...cambioFecha });
        }
    }

    /**
    Establece la hora hasta a la ultima hora del día 11:59 pm
    */
    private onFechaHastaChange = (x: Date | null, key: keyof models.FiltroRep) => {
        if (x) {
            var fecha = new Date(x);
            fecha.setHours(23, 59, 59);
            const viejo = this.props.value;
            const cambioFecha: Partial<models.FiltroRep> = { [key]: fecha };
            this.props.onChange({ ...viejo, ...cambioFecha });
        } else {
            const viejo = this.props.value;
            const cambioFecha: Partial<models.FiltroRep> = { [key]: null };
            this.props.onChange({ ...viejo, ...cambioFecha });
        }
    }
    
    render() {
        const { value } = this.props;
        const getField = this.getField;
        const Datetime = getField(kea.DateTime);
        const Cliente = getField(selectores.Cliente);
        const Folio = getField(FolioFactura);
        const SiNo = getField(selectores.SiNo);
        const EmpresaLogistica = getField(selectores.EmpresaLogistica);
        const Limite = getField(LimiteFacturas);

        return (
            <div>
                {kea.autogrid(2, [
                    <Datetime field="FechaInicio" label="Fecha de creación (inicio):" onChange={x => this.onFechaDesdeChange(x, "FechaInicio")} />,
                    <Datetime field="FechaFinal" label="Fecha de creación (final):" onChange={x => this.onFechaHastaChange(x, "FechaFinal")} />,
                    <Datetime field="FechaPagoInicio" label="Fecha de pago (inicio):" onChange={x => this.onFechaDesdeChange(x, "FechaPagoInicio")} />,
                    <Datetime field="FechaPagoFinal" label="Fecha de pago (final):" onChange={x => this.onFechaHastaChange(x, "FechaPagoFinal")} />,
                    <Folio field="SerieFolio" label="Folio del REP" />,
                    <Folio field="SerieFolioFactura" label="Folio de la factura" />,
                    <Cliente field="IdCliente" label="Cliente:" />,
                    <SiNo field="EsTimbrada" label="Timbrada" />,
                    <SiNo field="EsCancelada" label="Cancelada" />,
                    <Limite field="Limite" label="Limite" />,
                    <EmpresaLogistica field="EsRepLogistica" label="Empresa" />,
                ])}
            </div>);
    }
}


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/cobranza/reps/filtro.tsx